@if (isShown) {
  <div [class]="'message-banner message-banner-' + message.severity">
    <div
      class="message-banner-content"
    [class]="{
      'message-banner-content-inline': isInline && !isExpandable
    }"
      >
      @if (isExpandable) {
        <button
          class="message-banner-expander-btn"
          type="button"
          (click)="handleCollapsing()"
          >
          <i [class]="isCollapsed ? 'pi pi-chevron-down' : 'pi pi-chevron-up'"></i>
        </button>
      }
      <div>
        <div class="flex justify-start gap-2">
          <span class="message-banner-icon">
            <i class="pi" [class]="{
              'pi-info-circle': message.severity === 'info',
              'pi-exclamation-triangle': message.severity === 'warn',
              'pi-times-circle': message.severity === 'error',
              'pi-check': message.severity === 'success'
            }"></i>
          </span>

          <div class="message-banner-summary">
            <span class="font-bold">{{message.summary}}</span>{{message.result}}
          </div>
        </div>
        
        @if (message.detail) {
          <div [@openClose]="collapsingState()" class="message-banner-detail" [innerHTML]="message.detail"></div>
        }
      </div>
      @if (isClosable) {
        <button
          class="message-banner-close"
          type="button"
          (click)="isShown = false"
          >
          <i class="pi pi-times"></i>
        </button>
      }
    </div>
  </div>
}
